/* Phone-only sticky Add to cart bar. Clicks the product form's own button, never adds by itself. */
(function () {
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) return;
  var real = document.querySelector('form.product__form button[name="add"]');
  if (!real) return;
  var btn = bar.querySelector('[data-sticky-atc-button]');
  var priceEl = bar.querySelector('[data-sticky-atc-price]');
  var phone = window.matchMedia('(max-width: 749px)');
  var realOnScreen = true;

  bar.hidden = false;

  // Look like the real button, whatever colours the theme editor sets.
  var rs = getComputedStyle(real);
  ['backgroundColor', 'color', 'fontFamily', 'borderRadius', 'letterSpacing', 'textTransform'].forEach(function (k) {
    btn.style[k] = rs[k];
  });
  bar.style.backgroundColor = getComputedStyle(document.body).backgroundColor;

  // Price shown = the selected Kaching subscription or bundle option if there is one, else the theme's own price.
  function syncPrice() {
    var p = document.querySelector('.kaching-subscriptions__card-wrapper.selected .kaching-subscriptions__card-price-wrapper') ||
      document.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price') ||
      document.querySelector('[data-product-price] ins') ||
      document.querySelector('[data-product-price]');
    if (p && p.querySelector('del')) {
      p = p.cloneNode(true);
      p.querySelectorAll('del').forEach(function (d) { d.remove(); });
    }
    var m = p && p.textContent.match(/\$\s?[\d,]+(\.\d\d)?/);
    if (m) priceEl.textContent = m[0].replace(/\s/g, '');
  }

  // Lift the bar above the Klaviyo teaser tab when it is showing at the bottom of the screen.
  function liftAboveTeaser() {
    var t = document.querySelector('[class*="kl-teaser"]');
    var lift = 0;
    if (t && t.offsetHeight) {
      var r = t.getBoundingClientRect();
      if (r.bottom >= window.innerHeight - 2 && r.height < 120) lift = Math.round(window.innerHeight - r.top);
    }
    bar.style.bottom = lift ? lift + 'px' : '';
  }

  function update() {
    var show = phone.matches && !realOnScreen && !real.disabled && !document.querySelector('cart-drawer.is-visible');
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    btn.tabIndex = show ? 0 : -1;
    syncPrice();
    if (show) liftAboveTeaser();
  }

  function check() {
    var r = real.getBoundingClientRect();
    realOnScreen = r.bottom > 0 && r.top < window.innerHeight && r.height > 0;
    update();
  }
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check);

  btn.addEventListener('click', function () {
    syncPrice();
    real.click();
  });

  document.addEventListener('click', function () { setTimeout(update, 50); }, true);
  window.addEventListener('scroll', function () { if (bar.classList.contains('is-visible')) liftAboveTeaser(); }, { passive: true });
  phone.addEventListener && phone.addEventListener('change', update);
  check();
})();
